<template lang="pug">
  .form-group
    .checkbox.checkbox-rich(v-if="isBulkEdit" :class="{checked: data.checked}")
      label
        input(type="checkbox", :checked="data.checked" @change="changeChecked($event, $event.target.checked)")
        span: i.fa.fa-check.fa-lg
    label.control-label(:for="'edit_' + data.field") {{data.label}}
      span.bcard-required(v-if="data.required") (*)
    input.form-control(:id="'edit_' + data.field", :name="data.field", type="text", v-model="data.value", @input="changeChecked($event, true)", :maxlength="maxlength", :required="data.required", :data-testId="'-' + data.field")
</template>

<script>
export default {
  name: 'CardField',
  props: {
    /**
     * @type Object value
     * @param {String} label
     * @param {String} field
     * @param {String} value
     * @param {Boolean} checked
     * @param {Boolean} required (optional)
     */
    value: { type: Object, required: true },
    maxlength: { type: Number, required: true },
    isBulkEdit: { type: Boolean, required: false, default: false }
  },
  data: function () {
    return {
      data: {} // local value
    }
  },
  watch: {
    value () {
      this.syncData()
    }
  },
  created () {
    this.syncData()
  },
  methods: {
    syncData () {
      this.data = this.value
    },
    changeChecked ($event, checked) {
      this.data.$event = $event
      this.data.checked = checked
      this.$emit('input', this.data)
    }
  }
}
</script>

<style lang="scss" scoped>
  .checkbox-rich {
    position: absolute;
    margin-top: 0;
    z-index: 1;
    margin-left: -8.33333%;
  }
</style>



// WEBPACK FOOTER //
// src/components/molecules/CardField.vue